import ENV from '../env';

const { IQBASE } = ENV;

export const getProjectComparisionData = ({
  versionCurrent,
  projectId,
  versionOld,
}) => fetch(`${IQBASE}/miq/v2/compareProjects`, {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
  },
  body: JSON.stringify({
    versionCurrent,
    projectId,
    versionOld,
  }),
}).then(response => response.json());



// WEBPACK FOOTER //
// ./src/apis/index.js